import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ACCOUNT_CREATE_STEP } from '@components-member/TradingAccounts/AccountCreate/interfaces';
import { ButtonPreloader } from '@components-shared/preloader';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { AccountCreateContext } from '../../context';
import styles from './styles.module.scss';

interface IFormButtonsProps {
  disabled: boolean;
  createAction: () => void;
  changeStepHandler: (step: ACCOUNT_CREATE_STEP) => void;
  isBackButtonDisplayed: boolean;
  isCreatingTradingAccount: boolean;
}

export const AccountCreateButtons = (props: IFormButtonsProps) => {
  const { setSelectedPlatformType } = useContext(AccountCreateContext);
  const { disabled, createAction, changeStepHandler, isBackButtonDisplayed, isCreatingTradingAccount } = props;

  const { i18n } = useTranslation();

  const onClickBackButton = useCallback(() => {
    changeStepHandler(ACCOUNT_CREATE_STEP.PLATFORMS);
    setSelectedPlatformType('None');
  }, [changeStepHandler, setSelectedPlatformType]);

  const createButtonClassName = cn(
    'form__button',
    !isBackButtonDisplayed && styles.accountCreateButtons__createButton_width,
  );

  return (
    <div className={styles.accountCreateButtons}>
      <button onClick={createAction} disabled={disabled} className={createButtonClassName}>
        {isCreatingTradingAccount ? <ButtonPreloader /> : i18n.t(keyMap.tradingAccountsOpenAccount)}
      </button>
      {isBackButtonDisplayed && (
        <button onClick={onClickBackButton} className="link-btn">
          {i18n.t(keyMap.sharedActionsBack)}
        </button>
      )}
    </div>
  );
};
